import script from "./DestinyMatrixPurchadesDatesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DestinyMatrixPurchadesDatesTable.vue?vue&type=script&setup=true&lang=ts"

import "./DestinyMatrixPurchadesDatesTable.vue?vue&type=style&index=0&id=d9dd075c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9dd075c"]])

export default __exports__